import axios from 'axios';
import PageInterface from '@/interfaces/PageInterface';
import MenuInterface from '@/interfaces/MenuInterface';
import DistrictOfficeInterface from '@/interfaces/DistrictOfficeInterface';
import ContactPersonInterface from '@/interfaces/ContactPersonInterface';
import PartnerInterface from '@/interfaces/PartnerInterface';
import EventInterface from '@/interfaces/EventInterface';

export default {
  getFrontPage(): Promise<PageInterface> {
    return new Promise((resolve, reject) => {
      axios.get<PageInterface>(`${process.env.VUE_APP_API_BASE_PATH}frontpage`).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getPage(slug: string): Promise<PageInterface> {
    return new Promise((resolve, reject) => {
      axios.get<PageInterface>(`${process.env.VUE_APP_API_BASE_PATH}pages-nested`, {
        params: {
          slug,
        },
      }).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getMenu(slug: number | string): Promise<MenuInterface> {
    return new Promise((resolve, reject) => {
      axios.get<MenuInterface>(`${process.env.VUE_APP_API_BASE_PATH}menu`, {
        params: {
          slug,
        },
      }).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getDistrictOffices(): Promise<DistrictOfficeInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get<DistrictOfficeInterface[]>(`${process.env.VUE_APP_API_BASE_PATH}district-offices`).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getContactPersons(): Promise<ContactPersonInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get<ContactPersonInterface[]>(`${process.env.VUE_APP_API_BASE_PATH}contact-persons`).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getPartners(): Promise<PartnerInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get<PartnerInterface[]>(`${process.env.VUE_APP_API_BASE_PATH}partners`).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        reject(e);
      });
    });
  },
  getEvents(): Promise<EventInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get<EventInterface[]>(`${process.env.VUE_APP_API_BASE_PATH}events`).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        reject(e);
      });
    });
  },
};
